import React from "react";
import Header from "../components/Header/Header";
// import Layout from "../components/layout/Layout";
import MainPage from "../components/MainPage/MainPage";
import Layout from "../components/Layout/Layout";
import SideBar from "../components/SideBar/SideBar";

const Main = () => {
  return (
    <>
      <Header />
      <SideBar />
      <Layout>
        <MainPage />
      </Layout>
    </>
  );
};

export default Main;
